/**
 * Plantes vivantes hors saison (novembre à mars) : contrôle côté navigateur.
 *
 * La saison est d'abord calculée par le serveur (snippets/live-plant-season.liquid),
 * puis recontrôlée dans le <head> avec la date du jour : la classe
 * `live-plants-off-season` sur <html> pilote l'affichage (assets/live-plants.css).
 * Ce script garde les commandes cohérentes avec cette classe :
 * - désactive l'ajout au panier des plantes vivantes (fiche, ajout rapide), y compris
 *   après un changement de variante ;
 * - suit la présence d'une plante vivante dans le panier (classe `cart-has-live-plants`)
 *   et bloque le passage au paiement tant qu'elle y est.
 */
(function () {
  var config = window.legbaLivePlants;
  if (!config) return;

  var root = document.documentElement;
  var CONTROL_SELECTOR =
    '[data-live-plant].live-plant-in-season-only button, [data-live-plant].live-plant-in-season-only input, ' +
    '[data-live-plant] .live-plant-in-season-only button, [data-live-plant] .live-plant-in-season-only input, ' +
    '[data-live-plant] .live-plant-in-season-only select';
  var CHECKOUT_SELECTOR = 'button[name="checkout"], input[name="checkout"]';

  function isOffSeason() {
    return root.classList.contains('live-plants-off-season');
  }

  function isCheckoutBlocked() {
    return isOffSeason() && root.classList.contains('cart-has-live-plants');
  }

  // N'active jamais un élément désactivé pour une autre raison (rupture, panier vide) :
  // seuls les éléments marqués data-live-plant-disabled sont réactivés.
  function setDisabled(element, disabled) {
    if (disabled) {
      if (!element.disabled) {
        element.disabled = true;
        element.setAttribute('data-live-plant-disabled', '');
      }
    } else if (element.hasAttribute('data-live-plant-disabled')) {
      element.disabled = false;
      element.removeAttribute('data-live-plant-disabled');
    }
  }

  function enforce() {
    var offSeason = isOffSeason();
    document.querySelectorAll(CONTROL_SELECTOR).forEach(function (element) {
      setDisabled(element, offSeason);
    });

    var blocked = isCheckoutBlocked();
    document.querySelectorAll(CHECKOUT_SELECTOR).forEach(function (element) {
      setDisabled(element, blocked);
    });
  }

  var scheduled = false;
  function scheduleEnforce() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(function () {
      scheduled = false;
      enforce();
    }, 0);
  }

  function refreshCart() {
    if (!isOffSeason()) {
      enforce();
      return;
    }
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    fetch(cartUrl + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var hasLivePlants = (cart.items || []).some(function (item) {
          return item.product_type === 'Plante vivante';
        });
        root.classList.toggle('cart-has-live-plants', hasLivePlants);
        enforce();
      })
      .catch(function () {
        enforce();
      });
  }

  // Dernier rempart : aucun envoi de formulaire d'achat d'une plante vivante hors saison,
  // et aucun passage au paiement tant qu'une plante vivante est dans le panier.
  document.addEventListener(
    'submit',
    function (event) {
      if (!isOffSeason()) return;

      var form = event.target;
      var submitter = event.submitter;
      var isLivePlantForm = form.closest && form.closest('[data-live-plant]');
      var isCheckout =
        (submitter && submitter.name === 'checkout') || /\/checkout/.test(form.getAttribute('action') || '');

      if (isLivePlantForm || (isCheckout && root.classList.contains('cart-has-live-plants'))) {
        event.preventDefault();
        event.stopImmediatePropagation();

        if (isCheckout) {
          var warning = document.querySelector('.live-plant-cart-warning');
          var onCartPage = /\/cart\/?$/.test(window.location.pathname);
          if (onCartPage && warning) {
            warning.scrollIntoView({ behavior: 'smooth', block: 'center' });
          } else if (!onCartPage) {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          }
        }
      }
    },
    true
  );

  // Les boutons peuvent être réactivés par le thème (changement de variante, panier
  // réaffiché, fenêtre d'ajout rapide) : on réapplique la règle à chaque changement.
  new MutationObserver(scheduleEnforce).observe(root, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['disabled'],
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCart);
  }

  enforce();
  refreshCart();
})();
